import { Grid, SubHeading, SelectField, TextField, NAToggleField, FieldShell } from "../Fields";
import { useWizard } from "../WizardContext";
import { calcAge } from "../../../lib/formData";
import { HEIGHTS, COMPLEXIONS, RELIGIONS, MARITAL_STATUSES, GANAS, RASHIS, BLOOD_GROUPS, FOOD_HABITS } from "../../../lib/options";

function ProfileForPicker() {
  const { data, set, errors } = useWizard();
  const value = data.candidate.profile_for;
  const card = (v, label) => (
    <button
      type="button"
      key={v}
      data-testid={`field-candidate-profile_for-${v}`}
      onClick={() => set("candidate", "profile_for", v)}
      className={`flex-1 rounded-xl border-2 px-4 py-3 font-display text-xl font-semibold transition-colors ${value === v ? "border-[#7A0016] bg-[#7A0016] text-[#F5E6BA]" : "border-[#D4AF37]/50 bg-white text-[#4A000E] hover:bg-[#F5E6BA]/40"}`}
    >
      {label}
    </button>
  );
  return (
    <FieldShell id="candidate-profile_for" label="Registering for" required error={errors["candidate.profile_for"]} className="sm:col-span-2">
      <div className="flex gap-3">{card("bride", "Bride")}{card("groom", "Groom")}</div>
    </FieldShell>
  );
}

function AgeDisplay() {
  const { data } = useWizard();
  const age = calcAge(data.candidate.dob);
  return (
    <FieldShell id="candidate-age" label="Age (auto-calculated)">
      <div data-testid="field-candidate-age-readonly" className="flex h-10 items-center rounded-md border border-dashed border-[#D4AF37]/70 bg-[#F4EFEA] px-3 text-sm font-semibold text-[#7A0016]">
        {age !== null && age >= 0 ? `${age} years` : "Select date of birth"}
      </div>
    </FieldShell>
  );
}

export default function StepCandidate() {
  const today = new Date().toISOString().slice(0, 10);
  return (
    <Grid>
      <ProfileForPicker />
      <TextField section="candidate" name="full_name" label="Full name of bride/groom" required className="sm:col-span-2" />
      <TextField section="candidate" name="dob" label="Date of birth" type="date" max={today} required />
      <AgeDisplay />
      <TextField section="candidate" name="time_of_birth" label="Time of birth" type="time" />
      <TextField section="candidate" name="place_of_birth" label="Place of birth" required />
      <TextField section="candidate" name="mother_tongue" label="Mother tongue" required />
      <SelectField section="candidate" name="height" label="Height" required options={HEIGHTS} />
      <TextField section="candidate" name="weight" label="Weight" placeholder="e.g. 58 kg" />
      <SelectField section="candidate" name="complexion" label="Complexion" options={COMPLEXIONS} />
      <SelectField section="candidate" name="religion" label="Religion" required options={RELIGIONS} />
      <TextField section="candidate" name="nationality" label="Nationality" required />
      <SelectField section="candidate" name="marital_status" label="Marital status" required options={MARITAL_STATUSES} />
      <SubHeading>Horoscope</SubHeading>
      <SelectField section="candidate" name="gana" label="Gana" options={GANAS} />
      <SelectField section="candidate" name="rashi" label="Rashi" options={RASHIS} />
      <NAToggleField name="manglik" metaKey="manglik_yes" label="Manglik" className="sm:col-span-2" />
      <SubHeading>Community &amp; lifestyle</SubHeading>
      <TextField section="candidate" name="caste" label="Caste" />
      <TextField section="candidate" name="sub_caste" label="Sub-caste" />
      <SelectField section="candidate" name="blood_group" label="Blood group" options={BLOOD_GROUPS} />
      <SelectField section="candidate" name="food_habits" label="Food habits" required options={FOOD_HABITS} />
      <NAToggleField name="physically_challenged" metaKey="pc_yes" label="Physically challenged" className="sm:col-span-2" />
    </Grid>
  );
}
